import { IStore } from '../../store';
import { jobSelectors } from '../../_core/job';
import { EBFL2Actions } from './actions';
import { IBFL2Store } from './@types';

const bfl2Selectors = {
    _getStore(store: IStore) {
        return store.app.bfl2;
    },
    getHistoryList(store: IBFL2Store) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: IBFL2Store) {
        return {
            ...store.filter,
            shownRecords: store.filter.shownRecords
                ? store.filter.shownRecords
                : 'ALL',
        };
    },
    jobToLoadHistory(store: IBFL2Store) {
        return jobSelectors.getJobStatus(store, EBFL2Actions.HISTORY_LOAD);
    },
};
export default bfl2Selectors;
